<template>
    <div class="context">
        <div class="header">
            <div class="btn_box">
                <div class="btn nomal_btn" @click="goBack">
                    <i class="el-icon-back"></i>
                    返回
                </div>
            </div>
            <div class="title">{{viewTitle}}</div>
        </div>

        <div class="main_bing_box">
            <div class="main_box">
                <div class="main_title">
                    <span>1. 基本信息</span>
                    <span class="btn_span" v-if="edit_one">
                    <el-button plain
                               type="primary"
                               size="small"
                               @click="editMsg('one')">编辑</el-button>
                </span>
                </div>
                <el-form :model="form"
                         ref="ruleForm"
                         label-width="120px"
                         :disabled="edit_one"
                         :rules="rules">
                    <el-form-item label="医院名称:" prop="name">
                        <el-input v-model="form.name"
                                  class="width_300"
                                  placeholder="请输入医院名称"></el-input>
                    </el-form-item>
                    <el-form-item label="医院级别:" prop="level">
                        <el-select v-model="form.level" placeholder="请选择医院级别">
                            <el-option v-for="(item, index) in levelOption"
                                       :label="item"
                                       :value="item"
                                       :key="index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="医院编码:" prop="code">
                        <el-input v-model="form.code"
                                  class="width_220"
                                  placeholder="请输入医院编码"></el-input>
                    </el-form-item>
                    <el-form-item label="医院logo:">
                        <ImgCutter v-on:cutDown="fileChange"
                                   :size-change="false"
                                   :move-able="false"
                                   style="width: 110px">
                            <el-button style="margin-bottom: 20px" slot="open">选择图片</el-button>
                        </ImgCutter>
                        <el-image
                                style="width: 100px; height: 100px"
                                :src="form.logo_path"
                                v-if="form.logo_path"
                                fit="contain">
                            <div slot="placeholder" class="image-slot">
                                暂无图片
                            </div>
                        </el-image>
                    </el-form-item>
                    <el-form-item label="医院地址:" prop="address_list">
                        <el-cascader
                                v-model="form.address_list"
                                :options="addressOption"
                                :props="{
                                expandTrigger: 'hover',
                                value: 'label',
                             }"
                                class="width_300"
                                @change="addressChange"></el-cascader>
                    </el-form-item>
                    <el-form-item label="详细地址:">
                        <el-input v-model="form.address"
                                  class="width_600"
                                  placeholder="请输入医院详细地址"></el-input>
                    </el-form-item>
                    <el-form-item v-show="!edit_one">
                        <el-button type="primary" @click="submit">保存</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="main_box" v-show="showTwo">
                <div class="main_title">
                    <span>2. 详细信息</span>
                    <span class="btn_span" v-if="showEditBtn && edit_two">
                    <el-button plain
                               type="primary"
                               size="small"
                               @click="editMsg('two')">编辑</el-button>
                </span>
                </div>

                <div class="input_box_all">
                    <el-card v-for="(item, index) in detailForm"
                             :key="index"
                             class="card_item"
                             :class="edit_two?'less_height':''"
                             shadow="never">
                        <el-form :model="item"
                                 ref="detailForm"
                                 :rules="detailRules"
                                 :disabled="edit_two"
                                 label-width="100px">
                            <el-form-item label="医护人员" prop="name">
                                <el-input v-model="item.name"
                                          placeholder="请输入医护人员"
                                          class="width_220"></el-input>
                            </el-form-item>
                            <el-form-item label="手机号" prop="phone">
                                <el-input v-model="item.phone"
                                          placeholder="请输入医护人员"
                                          class="width_220"></el-input>
                            </el-form-item>
                            <el-form-item label="科室" prop="office">
                                <el-select v-model="item.office"
                                           placeholder="请选择科室"
                                           class="width_220">
                                    <el-option  v-for="item in officeOption"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="销售" prop="rep_id">
                                <el-select v-model="item.rep_id"
                                           placeholder="请选择销售"
                                           class="width_220">
                                    <el-option  v-for="item in sellOption"
                                                :key="item.user_id"
                                                :label="item.name"
                                                :value="item.user_id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-show="!edit_two">
                                <el-button plain type="primary" @click="editDetail(index)">保存</el-button>
                                <el-button type="danger" @click="delItem(item)">删除</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card class="card_item"
                             v-show="!edit_two"
                             shadow="never">
                        <el-form :model="addForm"
                                 ref="addForm"
                                 :rules="detailRules"
                                 label-width="100px">
                            <el-form-item label="医护人员" prop="name">
                                <el-input v-model="addForm.name"
                                          placeholder="请输入医护人员"
                                          class="width_220"></el-input>
                            </el-form-item>
                            <el-form-item label="手机号" prop="phone">
                                <el-input v-model="addForm.phone"
                                          placeholder="请输入医护人员"
                                          class="width_220"></el-input>
                            </el-form-item>
                            <el-form-item label="科室" prop="office">
                                <el-select v-model="addForm.office"
                                           placeholder="请选择科室"
                                           class="width_220">
                                    <el-option  v-for="item in officeOption"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="销售" prop="rep_id">
                                <el-select v-model="addForm.rep_id"
                                           placeholder="请选择销售"
                                           class="width_220">
                                    <el-option  v-for="item in sellOption"
                                                :key="item.user_id"
                                                :label="item.name"
                                                :value="item.user_id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button  type="primary" @click="detailSubmit(addForm)">添加</el-button>
                                <el-button @click="resetAdd">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {clone} from "@/global/utils";
    import adress from "../../assets/json/adress"
    import ImgCutter from 'vue-img-cutter'

    export default {
        name: "add",
        components: {ImgCutter},
        data() {
            const checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入手机号'));
                }
                let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (reg.test(value)) {
                    callback()
                } else {
                    callback(new Error('请输入正确的手机号！'))
                }
            };
            return {
                viewTitle: '添加医院',
                form: {
                    name: '',
                    level: '',
                    code: '',
                    logo_path: '',

                    address_list: [],
                    province: '',
                    city: '',
                    region: '',
                    address: '',
                },
                rules: {
                    name: [{required: true, message: '请输入医院名称！', trigger: 'blur'}],
                    level: [{required: true, message: '请选择医院级别！', trigger: 'blur'}],
                    code: [{required: true, message: '请输入医院编码！', trigger: 'blur'}],
                    address_list: [{required: true, message: '请选择医院地址！', trigger: 'blur'}],
                },
                detailRules: {
                    name: [{required: true, message: '请输入医护人员！', trigger: 'blur'}],
                    office: [{required: true, message: '请选择科室！', trigger: 'blur'}],
                    rep_id: [{required: true, message: '请选择销售！', trigger: 'blur'}],
                    phone: [{required: true, validator: checkPhone, trigger: 'blur'}],
                },

                detailForm: [],
                addForm: {
                    name: '',
                    phone: '',
                    office: '',
                    rep_id: ''
                },

                edit_one: false,
                edit_two: false,
                showTwo: false,

                officeOption: [
                    {label: '肿瘤科', value: '肿瘤科'},
                    {label: '胸科', value: '胸科'},
                    {label: '呼吸内科', value: '呼吸内科'},
                    {label: '消化科', value: '消化科'},
                    {label: '内科', value: '内科'},
                    {label: '外科', value: '外科'},
                    {label: '其他', value: '其他'},
                ],
                sellOption: [],
                addressOption: adress,
                levelOption: ['三级甲等', '三级乙等', '三级丙等',
                '二级甲等','二级乙等','二级丙等',
                '一级甲等','一级乙等','一级丙等'],
            }
        },
        computed: {
            ...mapState('manageData', [
                'hos_data'
            ]),
            showEditBtn() {
                return this.viewTitle === '修改医院';
            }
        },
        mounted() {
            this.getRepData()
            if (this.hos_data) {
                this.viewTitle = '修改医院';
                this.form = clone(this.hos_data);
                if (this.form.city) {
                    this.form.address_list = [this.form.province, this.form.city, this.form.region]
                }

                this.showTwo = true;
                this.edit_one = true;
                this.edit_two = true;
                this.getDoctorData();
            } else {
                this.viewTitle = '添加医院';
                this.showTwo = false;
                this.edit_one = false;
                this.edit_two = false;
                this.form = {
                    name: '',
                    level: '',
                    code: '',
                    logo_path: '',

                    address_list: [],
                    province: '',
                    city: '',
                    region: '',
                    address: '',
                }
            }
        },
        methods: {
            fileChange(file) {
                this.form.logo_path = file.dataURL;
                // console.log(file, this.form);
            },
            addressChange(val) {
                console.log(val);
                if (val) {
                    this.form.province = val[0];
                    this.form.city = val[1];
                    this.form.region = val[2];
                }
            },

            getRepData() {
                let params = {

                };
                this.httpGet('/user/rep', params).then(res => {
                    this.sellOption = res.data
                })
            },

            getDoctorData() {
                let params = {
                    hospital_id: this.form.hospital_id
                };
                this.httpGet(`/hospital/doctor_rep`, params).then(res => {
                    this.detailForm = res.data;
                })
            },
            editMsg(val) {
                // console.log(val);
                switch (val) {
                    case 'one':
                        this.edit_one = false;
                        break;
                    case 'two':
                        this.edit_two = false;
                        break;
                }
            },
            goBack() {
                this.$emit('changeTopTab', 'tableView')
            },
            submit() {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let params = {
                            ...this.form
                        };

                        if (this.viewTitle === '添加医院') {
                            this.httpPost('/hospital', params).then(res => {
                                this.$message.success('添加成功！');
                                this.form = res.data; // 当前医院
                                if (this.form.city) {
                                    this.form.address_list = [this.form.province, this.form.city, this.form.region]
                                }
                                this.showTwo = true; // 展示详细信息
                                this.getDoctorData();
                                this.edit_one = true; // 保存后内容禁止修改
                            })
                        } else if (this.viewTitle === '修改医院') {
                            this.httpPut(`/hospital/${this.form.hospital_id}`,
                                params).then(res => {
                                this.$message.success('修改成功！');
                                this.edit_one = true; // 保存后内容禁止修改
                            })
                        }

                    }
                })
            },

            resetAdd() {
                this.$refs.addForm.resetField();
                this.addForm = {
                    name: '',
                    phone: '',
                    office: '',
                    rep_id: ''
                };
            },

            delItem(item) {
                this.$confirm('确定要删除该医生么？').then(() => {
                    this.httpDel(`/hospital/doctor_rep/${item.rel_id}`).then(res => {
                        this.$message.success('删除成功！');
                    })
                }).catch(() => {})
            },
            detailSubmit(item) {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        let params = {
                            ...item,
                            hospital_id: this.form.hospital_id
                        };
                        this.httpPost('/hospital/doctor_rep', params).then(res => {
                            this.$message.success('保存成功！');
                            this.getDoctorData();
                            this.resetAdd()
                        }).catch(err => {
                            this.$message.warning(err.msg)
                        })
                    }
                })

            },
            editDetail(index) {
                // console.log(this.$refs.detailForm, '418');
                this.$refs.detailForm[index].validate(valid => {
                    if (valid) {
                        let params = {
                            ...this.detailForm[index]
                        };
                        // console.log(params, '323');
                        this.httpPut(`/hospital/doctor_rep/${params.rel_id}`, params).then(res => {
                            this.$message.success('保存成功！');
                            this.getDoctorData();
                        }).catch(err => {
                            this.$message.warning(err.msg)
                        })
                    }
                })

            },

            submit_detail_all() {
                let params = [
                    ...this.detailForm
                ];
                console.log(params, '320');
                this.httpPost('/hospital/doctor_rep_batch', params).then(res => {
                    this.$message.success('更新成功！');
                    this.getDoctorData();
                    this.edit_two = true
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246, 247, 248);
    $btn_border: rgb(246, 247, 248);
    .context {
        width: 100%;
        height: 100%;
        background: $view_background;
        .header {
            width: 100%;
            line-height: 50px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            border-bottom: 1px solid #ddd;
            .title {

            }
            .btn_box {
                padding-right: 20px;
                .btn {
                    margin-top: 10px;
                    border: 1px solid $btn_border;
                }
            }
        }
        .main_bing_box {
            height: calc(100% - 50px);
            overflow-y: auto;
        }
        .main_box {
            padding: 10px;
            .main_title {
                line-height: 40px;
                width: 100%;
                box-sizing: border-box;
                padding: 0 20px;
                background: #fff;
                margin-bottom: 10px;
                .btn_span {
                    margin-left: 20px;
                }
            }

            .input_box_all {
                background: #fff;
                border-radius: 3px;
                padding: 5px;
                display: flex;
                /*padding-left: 100px;*/
                .input_item {
                    line-height: 40px;
                    display: flex;
                    flex-wrap: wrap;
                    align-content: flex-start;
                    padding-bottom: 5px;
                    &:last-child {
                        padding-bottom: 0;
                    }
                    .title {
                        flex: 0 0 50px;
                        width: 50px;
                        text-align: center;
                    }
                    .input_box {
                        flex: 0 0 220px;
                        span {
                            padding: 0 5px;
                        }
                    }
                    .jiange {
                        flex: 0 0 15px;
                    }
                    .btn_box {
                        flex: 0 0 80px;
                        width: 80px;
                        display: flex;
                        padding-left: 10px;
                        .icon {
                            width: 40px;
                            line-height: 40px;
                            font-size: 1.5rem;
                            cursor: pointer;
                            text-align: center;
                        }
                        .del_icon {
                            color: #F56C6C;
                        }
                    }
                }

                .submit_btn {
                    padding: 10px 10px;
                    margin-left: 100px;
                }

                .card_item {
                    width: 340px;
                    height: 300px;
                    padding-top: 15px;
                    margin: 0 5px 5px 0;
                }
                .less_height {
                    height: 250px;
                }
            }
        }
    }
</style>
